import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ReactComponent as ProgramDetails } from "../../../../assets/svg/program-details.svg";
import { IconWithText } from "../../../program/components/IconWithText";

const useStyles = makeStyles(() => ({
  container: {
    marginTop: 16,
    border: "1px solid #C5C5C5",
    borderRadius: 15,
    padding: "16px 32px",
    fontSize: 16,
    color: "#231F20",
  },
}));

interface ClassDescriptionWidgetProps {
  description: string;
}

export const ClassDescriptionWidget: FC<ClassDescriptionWidgetProps> = ({
  description,
}) => {
  const classes = useStyles();

  return (
    <div>
      <IconWithText Icon={ProgramDetails} title="Class Description" />
      <div
        className={classes.container}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};
